import React, { useState } from "react";
import "../Styles/shop.css";
import "../Styles/generalUse.css";

import alienMint from "../Pictures/alien-emoji.png";
import MintBox1 from "../components/MintBox1";
import MintBox2 from "../components/MintBox2";
import MintBox3 from "../components/MintBox3";
import MintBox4 from "../components/MintBox4";
import MintBox5 from "../components/MintBox5";
import MintBox6 from "../components/MintBox6";

function Shop() {
  const [selectedShop, setSelectedShop] = useState(1);
  const [mintCount1, setMintCount1] = useState(1);
  const [mintCount2, setMintCount2] = useState(1);
  const [mintCount3, setMintCount3] = useState(1);
  const [mintCount4, setMintCount4] = useState(1);
  const [mintCount5, setMintCount5] = useState(1);
  const [mintCount6, setMintCount6] = useState(1);
  return (
    <div className="shop">
      <div className="shop-categories-container">
        <div
          className={`shop-category ${
            selectedShop === 1 && "shop-category-active"
          }`}
          onClick={() => setSelectedShop(1)}
        >
          <img className="alien-mint-icon" alt="" src={alienMint} />
          $ELXR
        </div>
        <div
          className={`shop-category ${
            selectedShop === 2 && "shop-category-active"
          }`}
          onClick={() => setSelectedShop(2)}
        >
          <img className="alien-mint-icon" alt="" src={alienMint} />
          UFO
        </div>
        <div
          className={`shop-category ${
            selectedShop === 3 && "shop-category-active"
          }`}
          onClick={() => setSelectedShop(3)}
        >
          <img className="alien-mint-icon" alt="" src={alienMint} />
          Alien
        </div>
        <div
          className={`shop-category ${
            selectedShop === 4 && "shop-category-active"
          }`}
          onClick={() => setSelectedShop(4)}
        >
          <img className="alien-mint-icon" alt="" src={alienMint} />
          Pills
        </div>
      </div>
      {selectedShop === 1 && (
        <div className="shop-place">
          <div className="shop-elxr-buy-1">
            <div className="small-detail-text">
              Buy for a discount with vesting
            </div>
            <div className="shop-elxr-buy-tool">No bonds available</div>
          </div>
          <div className="shop-elxr-buy-2">
            <div className="small-detail-text">
              Buy instantly from trader joe
            </div>
            <div className="shop-elxr-buy-tool">
              <div className="small-detail-text">Current market price</div>
            </div>
          </div>
        </div>
      )}
      {selectedShop === 2 && (
        <div className="shop-place">
          <MintBox1 mintCount1={mintCount1} setMintCount1={setMintCount1} />
          <MintBox2 mintCount1={mintCount2} setMintCount1={setMintCount2} />
        </div>
      )}
      {selectedShop === 3 && (
        <div className="shop-place">
          <MintBox3 mintCount1={mintCount3} setMintCount1={setMintCount3} />
          <MintBox4 mintCount1={mintCount4} setMintCount1={setMintCount4} />
        </div>
      )}
      {selectedShop === 4 && (
        <div className="shop-place">
          <MintBox5 mintCount1={mintCount5} setMintCount1={setMintCount5} />
          <MintBox6 mintCount1={mintCount6} setMintCount1={setMintCount6} />
        </div>
      )}
    </div>
  );
}

export default Shop;
